module.exports = __webpack_public_path__ + "img/cap_01.00393c11.jpg";